define.alias("shared/components/shared/social/twitter-deprecation/modal", "settings/components/shared/social/twitter-deprecation/modal");